export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.BusinessPartners'

export const BUSINESS_PARTNERS_TABLE_CHANGE = 'BUSINESS_PARTNERS_TABLE_CHANGE'
export const BUSINESS_PARTNERS_TABLE_CHANGE_REQUEST = (id) => `BUSINESS_PARTNERS_TABLE_${id}_CHANGE_REQUEST`
export const BUSINESS_PARTNERS_TABLE_LOADING_TRUE = 'BUSINESS_PARTNERS_TABLE_LOADING_TRUE'
export const BUSINESS_PARTNERS_TABLE_DATA_RECEIVED = 'BUSINESS_PARTNERS_TABLE_DATA_RECEIVED'
export const BUSINESS_PARTNERS_TABLE_LOADING_FALSE = 'BUSINESS_PARTNERS_TABLE_LOADING_FALSE'
